import { ResourceClient } from 'clients/ResourceClient';
import { NumberIndexModel, NumberIndexModelProps } from 'models/NumberIndexModel';

export abstract class NumberIndexResourceClient<
  T extends NumberIndexModel<P>,
  P extends NumberIndexModelProps
> extends ResourceClient<T, P, number> {}
